import { render, staticRenderFns } from "./items-type-paint.vue?vue&type=template&id=44072482&scoped=true"
import script from "./items-type-paint.vue?vue&type=script&lang=js"
export * from "./items-type-paint.vue?vue&type=script&lang=js"
import style0 from "./items-type-paint.vue?vue&type=style&index=0&id=44072482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44072482",
  null
  
)

export default component.exports